import { render, staticRenderFns } from "./ProductDetailPage.vue?vue&type=template&id=c6b0eca2&scoped=true&"
import script from "./ProductDetailPage.vue?vue&type=script&lang=js&"
export * from "./ProductDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailPage.vue?vue&type=style&index=0&id=c6b0eca2&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b0eca2",
  null
  
)

export default component.exports